(() => {
  const boot = () => {
    const config = document.querySelector('[data-hircan-app-image-loader]');
    if (!config) return;
    const replacements = new Map([
      ['https://areviewsapp.com/images/loading_icons/default/loading.gif', { url: config.dataset.hircanAppImageLoader, alt: config.dataset.hircanAppLoadingAlt }],
      ['https://areviewsapp.com/images/loading.gif', { url: config.dataset.hircanAppUploadLoader, alt: config.dataset.hircanAppLoadingAlt }],
      ['data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=', { url: config.dataset.hircanAppTransparent, alt: '' }]
    ]);
    const convert = (image) => {
      const replacement = replacements.get(image.getAttribute('src'));
      if (!replacement) return;
      image.src = replacement.url;
      image.removeAttribute('srcset');
      image.alt = replacement.alt;
    };
    const visit = (node) => {
      if (!(node instanceof Element)) return;
      if (node.matches('img')) convert(node);
      node.querySelectorAll('img').forEach(convert);
    };
    document.querySelectorAll('img').forEach(convert);
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') convert(record.target);
        else record.addedNodes.forEach(visit);
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
